import { isObject } from '../_util/defineType';
export const isTooltipInfomationTitle = data => {
  return Array.isArray(data) && data.every(item => isObject(item) && item.hasOwnProperty('label'));
};